/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channelcolevent2Inputs */

const en_channelcolevent2 = /** @type {(inputs: Channelcolevent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attachment`)
};

const de_channelcolevent2 = /** @type {(inputs: Channelcolevent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anhang`)
};

/**
* | output |
* | --- |
* | "Attachment" |
*
* @param {Channelcolevent2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channelcolevent2 = /** @type {((inputs?: Channelcolevent2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channelcolevent2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channelcolevent2(inputs)
	return de_channelcolevent2(inputs)
});
export { channelcolevent2 as "channelColEvent" }